import script from "./OkrIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrIcon.vue?vue&type=script&setup=true&lang=js"

import "./OkrIcon.vue?vue&type=style&index=0&id=189e4a60&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-189e4a60"]])

export default __exports__